import axios from 'axios';

const jbAPI = axios.create({
  baseURL:  process.env.REACT_APP_JOB_BOARD_API_URL, //'http://localhost:2500/api', // change to your Node.js server URL
  headers: {
    'Content-Type': 'application/json',
  },
});

export default jbAPI;
